import LinearProgress from '@mui/material/LinearProgress'
import { useEffect, useState } from 'react'

export function LinearDeterminateProgress(props: any) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0
        }
        const diff = Math.random() * 10
        return Math.min(oldProgress + diff, 100)
      })
    }, 50)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return <LinearProgress variant="determinate" value={progress} {...props} />
}
